import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bike-setup" }

import { computed } from 'vue'
import { BikeCategory } from '@/types/bike'
import { useI18n } from 'vue-i18n'

import InlineSvg from 'vue-inline-svg'

import BikeCity from '@/assets/bike-city.svg'
import BikeCyclocross from '@/assets/bike-cyclocross.svg'
import BikeFullTriathlon from '@/assets/bike-full-triathlon.svg'
import BikeGravelElectric from '@/assets/bike-gravel-electric.svg'
import BikeGravel from '@/assets/bike-gravel.svg'
import BikeMtbCrossCountry from '@/assets/bike-mtb-cross-country.svg'
import BikeMtbElectric from '@/assets/bike-mtb-electric.svg'
import BikeMtbTrail from '@/assets/bike-mtb-trail.svg'
import BikeRoadElectric from '@/assets/bike-road-electric.svg'
import BikeRoad from '@/assets/bike-road.svg'
import BikeShortTriathlon from '@/assets/bike-short-triathlon.svg'
import BikeTimeTrial from '@/assets/bike-time-trial.svg'
import BikeTrekkingElectric from '@/assets/bike-trekking-electric.svg'
import BikeTrekking from '@/assets/bike-trekking.svg'


export default /*@__PURE__*/_defineComponent({
  __name: 'BikeSetup',
  props: {
    bikeCategory: { default: BikeCategory.ROAD },
    hideDelta: { type: Boolean, default: false },
    hideStackReach: { type: Boolean, default: false },
    reach: { default: 1 },
    stack: { default: 2 },
    saddleWidth: { default: 3 },
    saddleHeight: { default: 4 },
    saddleHeightDiff: { default: 5 },
    saddleToHandlebar: { default: 6 },
    saddleToHandlebarDiff: { default: 7 },
    saddleHandlebarDrop: { default: 8 },
    saddleHandlebarDropDiff: { default: 9 },
    pedalHeight: { default: 10 },
    pedalHeightDiff: { default: 11 },
    crankArmLength: { default: 12 },
    crankArmLengthDiff: { default: 13 }
  },
  setup(__props: any) {

const { t } = useI18n()

const props = __props

const getBikeImage = computed(() => {
  switch (props.bikeCategory) {
    case BikeCategory.CITY:
      return BikeCity
    case BikeCategory.CYCLOCROSS:
      return BikeCyclocross
    case BikeCategory.FULLTRIATHLON:
      return BikeFullTriathlon
    case BikeCategory.GRAVEL:
      return BikeGravel
    case BikeCategory.GRAVELELECTRIC:
      return BikeGravelElectric
    case BikeCategory.MTBCROSSCOUNTRY:
      return BikeMtbCrossCountry
    case BikeCategory.MTBELECTRIC:
      return BikeMtbElectric
    case BikeCategory.MTBTRAIL:
      return BikeMtbTrail
    case BikeCategory.ROAD:
      return BikeRoad
    case BikeCategory.ROADELECTRIC:
      return BikeRoadElectric
    case BikeCategory.SHORTTRIATHLON:
      return BikeShortTriathlon
    case BikeCategory.TIMETRIAL:
      return BikeTimeTrial
    case BikeCategory.TREKKING:
      return BikeTrekking
    case BikeCategory.TREKKINGELECTRIC:
      return BikeTrekkingElectric
    default:
      return BikeRoad
  }
})

const transform = (svg: any) => {
  const removeElements = [
    '#SizeDaST',
    '#SizeCaST',
    '#SizeOkST',
    '#SizeDaRE',
    '#SizeCaRE',
    '#SizeOkRE',
    '#SPCRSTLabel',
    '#SPCRSTDelta',
    '#SPCRSTEMSTLabel',
    '#SPCRDelta',
    '#STEMANLabel',
    '#STEMANDelta',
    '#STEMST',
    '#STEMSTDelta',
    '#HAST',
    '#HASTDelta',
    '#CPST',
    '#CPSTDelta',
    '#SSDelta',
    '#SS',
    '#SAHA',
    '#SAHADelta',
    '#STEMRE',
    '#STEMREDelta',
    '#HBRE',
    '#CPRE',
    '#SPCRSTEMST',
    '#CPREDelta',
    '#HBW',
    '#HBTOP',
    '#STEMAN',
    '#SPCRST',
    '#HBTOPExtent',
    '#Extent',
    '#HBAN',
    '#HBANDelta',
    '#HBREDelta',
  ]

  const removeDeltaElements = ['#GraphDelta', '#SAHEDelta', '#SAHBDelta']
  const elementsInMm = [
    '#SizeRecRELabelValue tspan',
    '#SizeRecSTLabelValue tspan',
    '#SADTOPValue tspan',
    '#SAHELabelValue tspan',
    '#SAHBLabelValue tspan',
    '#SAHBDROPLabelValue tspan',
    '#PDSTLabelValue tspan',
    '#CALabelValue tspan',
  ]

  const replaceElements = [
    { '#SizeRecRELabelValue tspan': props.reach },
    { '#SizeRecSTLabelValue tspan': props.stack },
    { '#SADTOPValue tspan': props.saddleWidth },
    { '#SAHELabelValue tspan': props.saddleHeight },
    { '#SAHEDeltaValue tspan': props.saddleHeightDiff },
    { '#SAHBLabelValue tspan': props.saddleToHandlebar },
    { '#SAHBDeltaValue tspan': props.saddleToHandlebarDiff },
    { '#SAHBDROPLabelValue tspan': props.saddleHandlebarDrop },
    { '#SAHBDROPDeltaValue tspan': props.saddleHandlebarDropDiff },
    { '#PDSTLabelValue tspan': props.pedalHeight },
    { '#PDSTDeltaValue tspan': props.pedalHeightDiff },
    { '#CALabelValue tspan': props.crankArmLength },
    { '#CADeltaValue tspan': props.crankArmLengthDiff },
  ]

  removeElements.forEach((element) => {
    svg.querySelector(element)?.remove()
  })

  if (props.hideDelta) {
    removeDeltaElements.forEach((element) => {
      svg.querySelector(element)?.remove()
    })
  }

  if (props.hideStackReach) {
    svg.querySelector('#Sizes')?.remove()
    svg.querySelector('#Stack-Range')?.remove()
    svg.querySelector('#Reach-Range')?.remove()
    svg.querySelector('#Hand-CP-Zone')?.remove()
  }

  replaceElements.forEach((element) => {
    const el = svg.querySelector(Object.keys(element)[0])

    if (el) {
      if (elementsInMm.includes(Object.keys(element)[0])) {
        el.textContent = `${Object.values(element)[0]} ${t('common.unit.mm')}`
      } else {
        switch (Math.sign(Object.values(element)[0])) {
          case 1:
            el.textContent = t('common.unit.plus')
            break

          case -1:
            el.textContent = t('common.unit.minus')
            break

          default:
            el.textContent = ''
        }
        el.textContent += Object.values(element)[0]
      }
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InlineSvg), {
      src: getBikeImage.value,
      onLoaded: transform
    }, null, 8, ["src"])
  ]))
}
}

})